import { createContext } from 'react';

import { ModalInterface, DefaultInterface } from '../../models/services/modal-interface';

const ModalContext = createContext<ModalInterface>(DefaultInterface);

export { ModalContext };